// High Tide v5.9 — reliable homepage refresh restoration for the 3D can.
(() => {
  const root = document.querySelector('.ht-home-v58');
  const state = window.__HT_HOME_REFRESH_STATE__;
  if (!root || !state || !state.shouldRestore) return;

  let heroReady = false;
  let restoreTimer = 0;

  const atTop = () => {
    if (state.restoreStarted) return;
    const previous = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = previous;
  };

  const clearSavedPosition = () => {
    try { sessionStorage.removeItem(state.key); } catch (error) {}
  };

  const finish = () => {
    state.restoreFinished = true;
    document.documentElement.classList.remove('ht-home-refresh-restoring');
    if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
      ScrollTrigger.update();
    }
    if (window.__ht && typeof window.__ht.syncPhase === 'function') {
      window.__ht.syncPhase();
    }
    clearSavedPosition();
  };

  const restore = () => {
    if (state.restoreStarted || !heroReady) return;

    const splash = document.getElementById('htSplash');
    if (splash && !document.body.classList.contains('ht-loaded')) {
      restoreTimer = window.setTimeout(restore, 120);
      return;
    }

    state.restoreStarted = true;
    document.documentElement.classList.add('ht-home-refresh-restoring');
    atTop();

    const startMove = () => {
      if (window.ScrollTrigger) ScrollTrigger.refresh();
      const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const targetY = Math.max(0, Math.min(state.targetY, maxY));

      // Leave the refreshed page visibly at the header for a brief moment,
      // then return to the saved section so the can starts from a valid phase.
      window.setTimeout(() => {
        if (window.__htLenis && typeof window.__htLenis.scrollTo === 'function') {
          window.__htLenis.scrollTo(targetY, {
            duration: 1.15,
            force: true,
            lock: true,
            onComplete: finish,
          });
          window.setTimeout(finish, 1800);
          return;
        }

        window.scrollTo({ top: targetY, behavior: 'smooth' });
        window.setTimeout(finish, 1250);
      }, 320);
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => requestAnimationFrame(() => requestAnimationFrame(startMove)));
    } else {
      requestAnimationFrame(() => requestAnimationFrame(startMove));
    }
  };

  atTop();
  document.addEventListener('hightide:hero-ready', () => {
    heroReady = true;
    restore();
  }, { once: true });

  // Safety fallback: a failed/blocked model must not strand the user at top.
  window.setTimeout(() => {
    if (!heroReady) {
      heroReady = true;
      restore();
    }
  }, 10000);

  window.addEventListener('pagehide', () => window.clearTimeout(restoreTimer), { once: true });
})();
